import * as React from 'react';
import { connect } from 'react-redux';

import Pagination from 'components/pagination/Pagination';

import { getPagination } from 'modules/create-new-profiles/utils/pagination';

import { changePage } from 'modules/create-new-profiles/reducers/actions';

import type {
  LocationWindow,
  Pagination as PaginationType
} from 'types';

interface StateProps {
  location: LocationWindow,
  pagination: PaginationType
}

interface DispatchProps {
  dispatchOnPageChange: (p: number) => void
}

type Props = StateProps & DispatchProps;

const CreateNewProfilesEntitiesListPagination = ({
  location,
  pagination,
  dispatchOnPageChange
}: Props): JSX.Element => (
  <Pagination
    location={location}
    meta={pagination}
    links={pagination.links}
    onClick={dispatchOnPageChange}
  />
);

const mapStateToProps = ({ createNewProfiles, router }): StateProps => ({
  location: router.location,
  pagination: getPagination(createNewProfiles.createEntitiesModal)
});

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchOnPageChange: page => {
    // Fragile and hacky, but short and doing what is necessary...
    const modal = document.querySelector('.modal-opener');

    if (modal) {
      modal.scrollTo(0, 0);
    }

    dispatch(changePage(page));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateNewProfilesEntitiesListPagination);
